import apiClient from './api';
import { FieldDefinition } from './accountTypeService';

export interface FieldTemplate {
  _id: string;
  id?: string;
  name: string;
  description?: string;
  category?: string;
  fieldDefinition: FieldDefinition;
  usageCount: number;
  createdAt: string;
  updatedAt: string;
}

export interface CreateFieldTemplateDto {
  name: string;
  description?: string;
  category?: string;
  fieldDefinition: FieldDefinition;
}

export interface UpdateFieldTemplateDto {
  name?: string;
  description?: string;
  category?: string;
  fieldDefinition?: FieldDefinition;
}

const fieldTemplateService = {
  /**
   * دریافت لیست همه قالب‌های فیلد
   */
  list: async (params?: {
    search?: string;
    category?: string;
    page?: number;
    limit?: number;
  }): Promise<{ data: FieldTemplate[]; total: number }> => {
    const queryParams: Record<string, any> = {};
    if (params?.search) queryParams.search = params.search;
    if (params?.category) queryParams.category = params.category;
    if (params?.page) queryParams.page = params.page;
    if (params?.limit) queryParams.limit = params.limit;

    const response = await apiClient.getPaginated<FieldTemplate>('/admin/field-templates', queryParams);
    return {
      data: response.items,
      total: response.meta.totalItems,
    };
  },

  /**
   * دریافت لیست دسته‌بندی‌های موجود
   */
  getCategories: async (): Promise<string[]> => {
    try {
      const result = await apiClient.get<string[]>('/admin/field-templates/categories');
      return Array.isArray(result) ? result : [];
    } catch (e) {
      console.error('Error fetching field template categories:', e);
      return [];
    }
  },

  /**
   * گرفتن یک قالب خاص
   */
  getOne: async (id: string): Promise<FieldTemplate> => {
    return await apiClient.get<FieldTemplate>(`/admin/field-templates/${id}`);
  },

  /**
   * ساخت قالب جدید
   */
  create: async (data: CreateFieldTemplateDto): Promise<FieldTemplate> => {
    return await apiClient.post<FieldTemplate>('/admin/field-templates', data);
  },

  /**
   * آپدیت قالب
   */
  update: async (id: string, data: UpdateFieldTemplateDto): Promise<FieldTemplate> => {
    return await apiClient.put<FieldTemplate>(`/admin/field-templates/${id}`, data);
  },

  /**
   * حذف قالب
   */
  remove: async (id: string): Promise<void> => {
    await apiClient.delete(`/admin/field-templates/${id}`);
  },

  /**
   * استفاده از قالب — usageCount را روی سرور +1 می‌کند و خود قالب را برمی‌گرداند.
   * فرانت باید fieldDefinition را deep-clone کند قبل از اضافه کردن به AccountType.
   */
  use: async (id: string): Promise<FieldTemplate> => {
    const response = await apiClient.post<FieldTemplate>(`/admin/field-templates/${id}/use`);
    return response;
  },
};

export default fieldTemplateService;
